module.exports = __webpack_public_path__ + "static/media/IMG_E2968a.fd64bc12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/andes/IMG_E2968a.jpg
// module id = 143
// module chunks = 0